var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBeautifulBeanCoRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    margin: "20px",
    viewBox: "0 0 1691.304 170.145",
    fill: "#d43631",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 596"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M189.711 22.01h76.431v15.833H236.3v90.75h-16.747v-90.75h-29.842z",
    "data-name": "Path 156"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.186 20.792v44.157c5.484-7.92 14.315-14.315 25.885-14.315 14.161 0 22.686 7.613 22.686 23.9v54.055h-15.836v-49.94c0-11.721-4.872-14.006-12.028-14.006-8.68 0-20.708 11.116-20.708 31.517v32.432h-15.832v-107.8z",
    "data-name": "Path 157"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.378 81.391h13.245V78.04c0-9.592-6.853-13.4-14.921-13.4-6.244 0-11.725 3.348-14.312 10.2l-14.466-3.041c3.2-12.943 14.161-21.165 28.933-21.165 17.814 0 30.6 7.765 30.6 30.3v47.656h-13.4l-1.521-10.049c-5.023 7-12.943 11.267-23.756 11.267-12.785 0-23.6-7.311-23.6-23.3.005-15.825 13.557-25.117 33.198-25.117zm-6.85 34.41c9.743 0 20.1-6.241 20.1-19.49V94.64h-13.857c-9.743 0-15.836 4.565-15.836 11.873-.002 5.177 2.891 9.288 9.593 9.288z",
    "data-name": "Path 158"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.924 51.852h12.791V30.687l15.836-9.895v31.06h19.947v14.009h-19.947v37.45c0 8.68 3.2 12.485 10.2 12.485a12.3 12.3 0 007.307-2.13l4.115 13.4a27.472 27.472 0 01-12.334 2.739c-14.467 0-25.125-8.525-25.125-27.406V65.861h-12.79z",
    "data-name": "Path 159"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.581 22.01c17.659 0 29.842 9.44 29.842 27.863 0 8.222-4.565 17.205-10.81 20.556 10.049 4.263 16.29 14.463 16.29 26.8 0 19.944-12.485 31.366-33.5 31.366h-39.588V22.01zm-21.018 15.833v26.188h19.49c9.44 0 14.618-4.411 14.618-13.091s-5.178-13.1-14.618-13.1zm0 42.024v32.89h20.556c12.33 0 18.729-5.787 18.729-16.445s-6.399-16.445-18.729-16.445z",
    "data-name": "Path 160"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677.123 94.64h-54.357c0 11.267 6.547 21.162 19.035 21.162a22.108 22.108 0 0020.1-12.943l13.552 5.324c-7.462 14.467-16.142 21.623-33.65 21.623-25.276 0-35.783-21.316-35.783-39.588s10.507-39.588 35.783-39.588c24.513 0 35.322 19.947 35.322 37.152zm-54.054-13.249h37.307c-1.373-8.529-7.159-16.748-18.574-16.748-10.508 0-17.058 7.156-18.733 16.748z",
    "data-name": "Path 161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720.009 81.391h13.245V78.04c0-9.592-6.85-13.4-14.921-13.4-6.244 0-11.725 3.348-14.312 10.2l-14.466-3.041c3.2-12.943 14.161-21.165 28.933-21.165 17.814 0 30.6 7.765 30.6 30.3v47.656h-13.4l-1.521-10.049c-5.023 7-12.943 11.267-23.756 11.267-12.784 0-23.6-7.311-23.6-23.3.005-15.825 13.557-25.117 33.198-25.117zm-6.85 34.41c9.743 0 20.1-6.241 20.1-19.49V94.64H719.4c-9.743 0-15.836 4.565-15.836 11.873 0 5.177 2.893 9.288 9.595 9.288z",
    "data-name": "Path 162"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811.125 128.593v-13.094a28.561 28.561 0 01-24.819 14.312c-13.4 0-22.534-8.068-22.534-22.992V51.852h15.836v49.944c0 10.352 4.72 14.006 11.876 14.006 9.895 0 19.641-11.721 19.641-32.886V51.852h15.836v76.741z",
    "data-name": "Path 163"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M838.141 51.852h12.791V30.687l15.836-9.895v31.06h19.947v14.009h-19.947v37.45c0 8.68 3.2 12.485 10.2 12.485a12.306 12.306 0 007.307-2.13l4.115 13.4a27.472 27.472 0 01-12.334 2.739c-14.467 0-25.125-8.525-25.125-27.406V65.861h-12.79z",
    "data-name": "Path 164"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M907.124 19.117a10.946 10.946 0 0110.961 11.117 10.962 10.962 0 01-21.922 0 10.949 10.949 0 0110.961-11.117zm7.92 32.735v76.741h-15.836V51.852z",
    "data-name": "Path 165"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M926.828 51.852h9.9v-3.96c0-18.726 10.2-27.1 25.734-27.1a28.33 28.33 0 0112.636 2.739l-3.2 13.4a18.5 18.5 0 00-8.983-2.133c-7 0-10.355 4.115-10.355 12.031v5.023h16.9v14.009h-16.9v62.731h-15.834V65.861h-9.9z",
    "data-name": "Path 166"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1027.053 128.593v-13.094a28.561 28.561 0 01-24.819 14.312c-13.4 0-22.538-8.068-22.538-22.992V51.852h15.836v49.944c0 10.352 4.724 14.006 11.88 14.006 9.894 0 19.641-11.721 19.641-32.886V51.852h15.836v76.741z",
    "data-name": "Path 167"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1075.199 20.792v107.8h-15.836v-107.8z",
    "data-name": "Path 168"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1170.061 22.01c17.659 0 29.842 9.44 29.842 27.863 0 8.222-4.565 17.205-10.81 20.556 10.046 4.263 16.29 14.463 16.29 26.8 0 19.944-12.485 31.366-33.5 31.366h-39.587V22.01zm-21.014 15.833v26.188h19.49c9.437 0 14.615-4.411 14.615-13.091s-5.178-13.1-14.615-13.1zm0 42.024v32.89h20.556c12.33 0 18.729-5.787 18.729-16.445s-6.398-16.445-18.729-16.445z",
    "data-name": "Path 169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1286.604 94.64h-54.354c0 11.267 6.544 21.162 19.032 21.162a22.109 22.109 0 0020.1-12.943l13.551 5.329c-7.462 14.467-16.142 21.623-33.65 21.623-25.273 0-35.783-21.316-35.783-39.588s10.51-39.588 35.783-39.588c24.513 0 35.322 19.947 35.322 37.152zm-54.051-13.249h37.307c-1.373-8.529-7.159-16.748-18.578-16.748-10.507 0-17.054 7.156-18.729 16.748z",
    "data-name": "Path 170"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1329.157 81.391h13.245V78.04c0-9.592-6.853-13.4-14.924-13.4-6.241 0-11.721 3.348-14.309 10.2l-14.467-3.045c3.2-12.943 14.16-21.165 28.93-21.165 17.814 0 30.605 7.765 30.605 30.3v47.656h-13.4l-1.516-10.043c-5.026 7-12.943 11.267-23.756 11.267-12.788 0-23.6-7.311-23.6-23.3-.004-15.827 13.551-25.119 33.192-25.119zm-6.853 34.41c9.746 0 20.1-6.241 20.1-19.49V94.64h-13.856c-9.746 0-15.836 4.565-15.836 11.873 0 5.177 2.89 9.288 9.592 9.288z",
    "data-name": "Path 171"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1389.359 51.852v13.1a28.561 28.561 0 0124.819-14.315c13.4 0 22.534 8.068 22.534 22.992v54.967h-15.836V78.649c0-10.352-4.717-14.006-11.873-14.006-9.9 0-19.645 11.721-19.645 32.886v31.063h-15.832v-76.74z",
    "data-name": "Path 172"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1561.899 57.029c-5.329-13.552-12.784-20.4-27.251-20.4-17.969 0-32.281 12.636-32.281 38.673s14.312 38.673 32.281 38.673c14.467 0 21.922-6.85 27.251-20.4l15.836 3.956c-5.477 20.1-20.4 32.281-43.087 32.281-25.734 0-49.331-18.423-49.331-54.509s23.6-54.509 49.331-54.509c22.686 0 37.61 12.179 43.087 32.277z",
    "data-name": "Path 173"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1623.422 50.634c23.752 0 37.758 17.969 37.758 39.588s-14.006 39.588-37.758 39.588-37.761-17.969-37.761-39.588 14.006-39.588 37.761-39.588zm0 65.167c13.854 0 21.014-12.636 21.014-25.579s-7.159-25.579-21.014-25.579-21.01 12.64-21.01 25.579 7.153 25.579 21.01 25.579z",
    "data-name": "Path 174"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1691.304 118.09a11.267 11.267 0 11-11.264-11.271 11.143 11.143 0 0111.264 11.271z",
    "data-name": "Path 175"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.813 156.164h552.385v13.98H522.813z",
    "data-name": "Rectangle 586"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 597"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.037 66.454a22.569 22.569 0 10-12.84 41.126h38.922c11.765 0 21.954-8.8 22.989-20.519A22.567 22.567 0 0091.93 66.356a12.187 12.187 0 01-13.893.098z",
    "data-name": "Path 649"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 371"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.856 83.858h31.157v2.297h-31.157z",
    "data-name": "Rectangle 845"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 83.858h31.157v2.297H0z",
    "data-name": "Rectangle 846"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.858 0h2.297v31.157h-2.297z",
    "data-name": "Rectangle 847"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.858 138.856h2.297v31.157h-2.297z",
    "data-name": "Rectangle 848"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.246 71.887l30.37366668-6.94255151.5118285 2.23925L137.75782852 74.12625z",
    "data-name": "Rectangle 849"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.881 102.828l30.37366668-6.94255151.5118285 2.23925L2.39282852 105.06725z",
    "data-name": "Rectangle 850"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.945 2.393l2.23925-.5118285 6.94255152 30.37366667-2.23925.5118285z",
    "data-name": "Rectangle 851"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.886 137.758l2.23924107-.51186759 6.94308163 30.3735455-2.23924107.5118676z",
    "data-name": "Rectangle 852"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.009 60.577l28.06305504-13.53601088.99792076 2.06890385-28.06305504 13.53601089z",
    "data-name": "Rectangle 853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.942 120.903l28.06305504-13.53601088.99792076 2.06890385-28.06305504 13.53601089z",
    "data-name": "Rectangle 854"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.041 8.941l2.06890386-.99792076L62.64591474 36.0061343l-2.06890386.99792075z",
    "data-name": "Rectangle 855"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.367 134.007l2.06890386-.99792076 13.53601088 28.06305505-2.06890386.99792075z",
    "data-name": "Rectangle 856"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.359 50.494l24.34134952-19.44883936 1.4344588 1.79530831-24.34134952 19.44883937z",
    "data-name": "Rectangle 857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.879 137.172l24.34134952-19.44883936 1.4344588 1.79530831-24.34134952 19.44883937z",
    "data-name": "Rectangle 858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.046 19.312l1.794738-1.433952 19.441968 24.333617-1.794738 1.433952z",
    "data-name": "Rectangle 859"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.723 127.793l1.794738-1.433952 19.441968 24.333617-1.794738 1.433952z",
    "data-name": "Rectangle 860"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.629 42.148l19.410811-24.395931 1.798551 1.431031-19.410811 24.395931z",
    "data-name": "Rectangle 861"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.191 150.819l19.39588546-24.38484348 1.79767589 1.42988475-19.39588546 24.38484348z",
    "data-name": "Rectangle 862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.764 32.988l1.42988475-1.7976759L43.5779456 50.58558707l-1.42988474 1.7976759z",
    "data-name": "Rectangle 863"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.435 119.426l1.431031-1.798551 24.395931 19.410811-1.431031 1.798551z",
    "data-name": "Rectangle 864"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.259 35.956l13.459824-28.103614 2.071894.992304-13.459824 28.103614z",
    "data-name": "Rectangle 865"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.208 161.155l13.459824-28.103614 2.071894.992304-13.459824 28.103614z",
    "data-name": "Rectangle 866"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.864 49.279l.992304-2.071894L36.959918 60.66693l-.992304 2.071894z",
    "data-name": "Rectangle 867"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.063 109.33l.992304-2.071894 28.103614 13.459824-.992304 2.071894z",
    "data-name": "Rectangle 868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.77 32.231l6.885697-30.378075 2.239575.507637-6.885697 30.378075z",
    "data-name": "Rectangle 869"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.127 167.663l6.885697-30.378075 2.239575.507637-6.885697 30.378075z",
    "data-name": "Rectangle 870"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.842 67.367l.5069029-2.24037016 30.3888607 6.8757396-.50690291 2.24037016z",
    "data-name": "Rectangle 871"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.275 98.01l.5069029-2.24037016 30.3888607 6.8757396-.50690291 2.24037016z",
    "data-name": "Rectangle 872"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.312 12.286l2.16764565-.75994826 5.268357 15.02724827-2.16764564.75994826z",
    "data-name": "Rectangle 873"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.264 143.356l2.16764565-.75994826 5.268357 15.02724827-2.16764564.75994826z",
    "data-name": "Rectangle 874"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.577 109.481l15.02724827-5.26835701.75994825 2.16764565-15.02724826 5.268357z",
    "data-name": "Rectangle 875"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.648 63.53l15.02724827-5.26835701.75994825 2.16764565-15.02724826 5.268357z",
    "data-name": "Rectangle 876"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.786 20.065l1.943262-1.224301 8.487492 13.471704-1.943262 1.224301z",
    "data-name": "Rectangle 877"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.798 137.594l1.943262-1.224301 8.487492 13.471704-1.943262 1.224301z",
    "data-name": "Rectangle 878"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.892 125.23l13.47670493-8.48246427 1.22357577 1.94398337-13.47670494 8.48246427z",
    "data-name": "Rectangle 879"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.421 51.218l13.47670493-8.48246427 1.22357577 1.94398337-13.47670494 8.48246427z",
    "data-name": "Rectangle 880"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.383 31.109l1.62195485-1.62649054L42.28063413 40.726745l-1.62195485 1.62649054z",
    "data-name": "Rectangle 881"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.732 129.184l1.62195485-1.62649054 11.27567928 11.24423553-1.62195485 1.62649054z",
    "data-name": "Rectangle 882"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.534 138.956l11.24423553-11.27567928 1.62649054 1.62195484-11.24423553 11.27567929z",
    "data-name": "Rectangle 883"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.608 40.608l11.24423553-11.27567928 1.62649054 1.62195484-11.24423553 11.27567929z",
    "data-name": "Rectangle 884"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.78 44.862l1.218924-1.9469035 13.49694883 8.45021588-1.21892401 1.94690351z",
    "data-name": "Rectangle 885"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.516 118.545l1.218924-1.9469035 13.49694883 8.45021588-1.21892401 1.94690351z",
    "data-name": "Rectangle 886"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.967 149.963l8.4478601-13.49842345 1.94711622 1.21858419-8.4478601 13.49842345z",
    "data-name": "Rectangle 887"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.651 32.227l8.4478601-13.49842345 1.94711622 1.21858419-8.4478601 13.49842345z",
    "data-name": "Rectangle 888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.51 60.633l.753416-2.170665 15.04818 5.223072-.753416 2.170665z",
    "data-name": "Rectangle 889"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.708 106.218l.753416-2.170665 15.04818 5.223072-.753416 2.170665z",
    "data-name": "Rectangle 890"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.516 157.698l5.223072-15.04818 2.170665.753416-5.223072 15.04818z",
    "data-name": "Rectangle 891"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.101 26.5l5.223072-15.04818 2.170665.753416-5.223072 15.04818z",
    "data-name": "Rectangle 892"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.937 77.63l.25117279-2.28423209 15.8285952 1.74050281-.2511728 2.28423209z",
    "data-name": "Rectangle 893"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.996 92.823l.25117279-2.28423209 15.8285952 1.74050281-.2511728 2.28423209z",
    "data-name": "Rectangle 894"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.397 161.773l1.74160785-15.82847365 2.28421455.25133225-1.74160785 15.82847366z",
    "data-name": "Rectangle 895"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.59 23.714l1.7418841-15.82844325 2.28421017.25137212-1.74188411 15.82844325z",
    "data-name": "Rectangle 896"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.979 92.711l15.81843597-1.83053527.26405046 2.28177264-15.81843597 1.83053526z",
    "data-name": "Rectangle 897"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.951 76.747l15.81843597-1.83053527.26405046 2.28177264-15.81843597 1.83053526z",
    "data-name": "Rectangle 898"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.932 146.163l2.28177263-.26405046 1.83053527 15.81843597-2.28177263.26405046z",
    "data-name": "Rectangle 899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.968 8.192l2.28177263-.26405046 1.83053527 15.81843597-2.28177263.26405046z",
    "data-name": "Rectangle 900"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeautifulBeanCoRed);
export default __webpack_public_path__ + "static/media/beautiful-bean-co-red.11c1359ff34c4ce574503a56a7f7dfea.svg";
export { ForwardRef as ReactComponent };